import { render, staticRenderFns } from "./_dollarRates.vue?vue&type=template&id=bc510522&scoped=true&"
import script from "./_dollarRates.vue?vue&type=script&lang=js&"
export * from "./_dollarRates.vue?vue&type=script&lang=js&"
import style0 from "./_dollarRates.vue?vue&type=style&index=0&id=bc510522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc510522",
  null
  
)

export default component.exports